import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { SymptomsChecklist } from '../components/SymptomsChecklist';
import { WhyMedicineFails } from '../components/WhyMedicineFails';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { ProductIntroduction } from '../components/ProductIntroduction';
import { BonusStack } from '../components/BonusStack';
import { ValueStackTable } from '../components/ValueStackTable';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { UrgencyBlock } from '../components/UrgencyBlock';
import { FinalCTA } from '../components/FinalCTA';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export const LandingPage = () => {
  return <>
      <AnnouncementBar data-id="element-281" />
      <HeroSection data-id="element-282" />
      <StorySection data-id="element-283" />
      <SymptomsChecklist data-id="element-284" />
      <WhyMedicineFails data-id="element-285" />
      <UniqueMechanism data-id="element-286" />
      <ProductIntroduction data-id="element-287" />
      <BonusStack data-id="element-288" />
      <ValueStackTable data-id="element-289" />
      <Testimonials data-id="element-290" />
      <Guarantee data-id="element-291" />
      <UrgencyBlock data-id="element-292" />
      <FinalCTA data-id="element-293" />
      <FAQ data-id="element-294" />
      <Footer data-id="element-295" />
    </>;
};